import React, { Component } from "react";
import {
  Button,
  Container,
  Grid,
  Message,
  Popup,
  Segment
} from "semantic-ui-react";

import { ChromePicker } from "react-color";

import request from "../../utils/request";
import { invertColor } from "../../utils/constants";
import DropzoneCommon from "../../components/content/DropzoneCommon";

class AdminTheme extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      xhrStatus: "",
      xhrMessage: "",
      primaryColor: "#235789",
      secondaryColor: "#de1630",
      accentColor: "#f1d302",
      brandLogo: `${process.env.PUBLIC_URL}/static/images/logo.png`
    };
  }
  componentDidMount = () => {
    this.fetchData();
  };
  startLoading = () => {
    this.setState({ isLoading: true });
  };
  doneLoading = () => {
    this.setState({ isLoading: false });
  };
  fetchData = () => {
    this.startLoading();
    return request.get(this, "api:/theme", {}).then(resp => {
      this.setState(
        {
          primaryColor: resp.primary ? resp.primary : "#235789",
          secondaryColor: resp.secondary ? resp.secondary : "#de1630",
          accentColor: resp.accent ? resp.accent : "#f1d302",
          brandLogo: resp.logo ? resp.logo : `${process.env.PUBLIC_URL}/static/images/logo.png`
        },
        this.doneLoading()
      );
    });
  };
  handlePrimaryColor = (color, event) => {
    this.setState({ primaryColor: color.hex });
  };
  handleSecondaryColor = (color, event) => {
    this.setState({ secondaryColor: color.hex });
  };
  handleAccentColor = (color, event) => {
    this.setState({ accentColor: color.hex });
  };
  handleUpload = files => {
    this.startLoading();
    // Initial FormData
    let formData = new FormData();
    formData.append("file", files[0]);

    return request.post(this, "api:/theme", formData).then(resp => {
      this.setState(
        {
          xhrStatus: resp.status,
          xhrMessage: resp.message,
          brandLogo: resp.url
        },
        this.doneLoading()
      );
    });
  };
  handleSubmit = () => {
    this.startLoading();
    this.setState({
      xhrStatus: "",
      xhrMessage: ""
    });
    let payload = {
      primary: this.state.primaryColor,
      secondary: this.state.secondaryColor,
      accent: this.state.accentColor
    };
    return request.put(this, "api:/theme/admin", payload).then(resp => {
      this.setState(
        {
          xhrStatus: resp.status,
          xhrMessage: resp.message
        },
        this.doneLoading()
      );
    });
  };
  render() {
    const {
      isLoading,
      primaryColor,
      secondaryColor,
      accentColor,
      brandLogo,
      xhrMessage,
      xhrStatus
    } = this.state;
    return (
      <Container fluid>
        <Segment basic loading={isLoading}>
          <Message
            hidden={xhrStatus === ""}
            content={xhrMessage}
            success={xhrStatus === "success"}
            error={xhrStatus === "error"}
          />
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <Segment basic>
                  Primary{" "}
                  <Popup
                    basic
                    style={{ padding: 0, boxShadow: 0 }}
                    trigger={
                      <Button
                        circular
                        floated="right"
                        icon="paint brush"
                        content="Background"
                        style={{
                          backgroundColor: primaryColor,
                          color: invertColor(primaryColor, 1)
                        }}
                      />
                    }
                    content={
                      <ChromePicker
                        color={primaryColor}
                        onChangeComplete={this.handlePrimaryColor}
                      />
                    }
                    on="click"
                    position="bottom left"
                  />
                </Segment>
                <Segment basic>
                  Secondary{" "}
                  <Popup
                    basic
                    style={{ padding: 0, boxShadow: 0 }}
                    trigger={
                      <Button
                        circular
                        floated="right"
                        icon="paint brush"
                        content="Background"
                        style={{
                          backgroundColor: secondaryColor,
                          color: invertColor(secondaryColor, 1)
                        }}
                      />
                    }
                    content={
                      <ChromePicker
                        color={secondaryColor}
                        onChangeComplete={this.handleSecondaryColor}
                      />
                    }
                    on="click"
                    position="bottom left"
                  />
                </Segment>
                <Segment basic>
                  Accent{" "}
                  <Popup
                    basic
                    style={{ padding: 0, boxShadow: 0 }}
                    trigger={
                      <Button
                        circular
                        floated="right"
                        icon="paint brush"
                        content="Background"
                        style={{
                          backgroundColor: accentColor,
                          color: invertColor(accentColor, 1)
                        }}
                      />
                    }
                    content={
                      <ChromePicker
                        color={accentColor}
                        onChangeComplete={this.handleAccentColor}
                      />
                    }
                    on="click"
                    position="bottom left"
                  />
                </Segment>
                <Button
                  primary
                  floated="right"
                  onClick={this.handleSubmit}
                  icon="save"
                  content="Submit"
                />
              </Grid.Column>
              <Grid.Column>
                <DropzoneCommon
                  img={brandLogo}
                  accept="image/*"
                  onDrop={this.handleUpload}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    );
  }
}

export default AdminTheme;
